import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';

const perimenopauseCardsData: LandingPageCardData[] = [
  {
    description: {
      messageKey: 'perimenopause_cycle_copy',
    },
    id: 'cycle_insights',
    image: {
      localizedAlt: 'perimenopause_ui_alt_cycle_changes',
      localizedSrc: 'perimenopause_cycle_app_tab_src',
    },
    title: {
      messageKey: 'perimenopause_cycle_title',
    },
  },
  {
    description: {
      messageKey: 'perimenopause_sleep_copy',
    },
    id: 'sleep',
    image: {
      localizedAlt: 'perimenopause_ui_alt_sleep',
      localizedSrc: 'perimenopause_sleep_app_tab_src',
    },
    title: {
      messageKey: 'perimenopause_sleep_title',
    },
  },
  {
    description: {
      messageKey: 'perimenopause_energy_copy',
    },
    id: 'energy',
    image: {
      localizedAlt: 'perimenopause_ui_alt_energy',
      localizedSrc: 'perimenopause_ready_app_tab_src',
    },
    title: {
      messageKey: 'perimenopause_energy_title',
    },
  },
];

export { perimenopauseCardsData };
